export const CREATE_PRODUCT_ATTRIBUTE = 'attributes/CREATE_PRODUCT_ATTRIBUTE'
export const FETCH_PRODUCT_ATTRIBUTE = 'attributes/FETCH_PRODUCT_ATTRIBUTE'
export const FETCH_PRODUCT_ATTRIBUTES_LIST = 'attributes/FETCH_PRODUCT_ATTRIBUTES_LIST'
export const REMOVE_PRODUCT_ATTRIBUTE = 'attributes/REMOVE_PRODUCT_ATTRIBUTE'
export const UPDATE_PRODUCT_ATTRIBUTE = 'attributes/UPDATE_PRODUCT_ATTRIBUTE'
